export default{
    config:'تنظیمات',
    taxForDoctors : 'نرخ مالیات برای پزشکان',
    currencyId : 'واحد پول',
    taxForHospital : 'نرخ مالیات برای مرکز',
    accountsReceivablePersonals : ' حساب های دریافتنی (اشخاص)',
    clinicServiceIncome : 'درآمد خدمات کلینیک',
    discount : 'تخفیفات',
    cash : 'صندوق',
    poses : 'حساب دستگاه های پوز',
    commercialPaymentsAccountsDoctors : 'حساب های پرداختنی تجاری _ پزشکان',
    organizationOfTaxDoctorsTax : 'سازمان امور مالیاتی _ مالیات پزشکان',
    organizationOfTaxHospitalsTax : 'سازمان امور مالیاتی _ مالیات مرکز',
    costOfDoctorsServices:'هزینه خدمات پزشکان',
    bankCards : 'حساب کارت های بانکی',
    receivedCash : 'حساب صندوق دریافتی',
    returnFromServicesRendered:'حساب برگشت از خدمات ارایه شده',
    excessReceived : 'حساب های اضافه دریافتی',
    commercialPaymentsAccountsPatients : 'حساب های پرداختنی تجاری _ بیمارها',
    hospitalShareFromIncome:'سهم مرکز از درآمد کسب شده',
    sideOfTheHospitalShareFromIncome:'طرف حساب سهم مرکز از درآمد کسب شده',
    donationClinicReceivableAccount:'حساب دریافتنی کلینیک اهداء',
    ipdReceivableAccount:'حساب دریافتنی IPD',
    donationClinicReceivedCashAccount:"حساب صندوق دریافتی از کلینیک اهداء",
    ipdReceivedCashAccount:"حساب صندوق دریافتی از IPD",
    cashImprestFunds : "تنخواه گردان صندوق",
    bankOfCompany : "بانک شرکت(نقدی)"

}